import React, { useState } from 'react';
import { User, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import AuthModal from './AuthModal';
import './AuthButton.css';

const AuthButton = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const { user, logout, isAuthenticated } = useAuth();

  const handleLogout = () => {
    logout();
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    if (isAuthenticated) {
      setIsDropdownOpen(!isDropdownOpen);
    } else {
      setIsAuthModalOpen(true);
    }
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  return (
    <div className="auth-button-container">
      <button 
        className="auth-button"
        onClick={toggleDropdown}
        title={isAuthenticated ? `Connecté en tant que ${user?.firstName}` : 'Se connecter'}
      >
        <User size={20} />
        {isAuthenticated && (
          <span className="auth-user-name">
            {user?.firstName}
          </span>
        )}
      </button>

      {isDropdownOpen && (
        <>
          <div className="auth-dropdown-overlay" onClick={closeDropdown} />
          <div className="auth-dropdown">
            {isAuthenticated ? (
              <>
                <div className="auth-user-info">
                  <div className="auth-user-avatar">
                    <User size={24} />
                  </div>
                  <div className="auth-user-details">
                    <div className="auth-user-name-full">
                      {user?.firstName} {user?.lastName}
                    </div>
                    <div className="auth-user-email">
                      {user?.email}
                    </div>
                    {user?.role === 'admin' && (
                      <div className="auth-user-role">
                        Administrateur
                      </div>
                    )}
                  </div>
                </div>
                
                <div className="auth-dropdown-divider" />
                
                <button 
                  className="auth-dropdown-item"
                  onClick={handleLogout}
                >
                  <LogOut size={18} />
                  Se déconnecter
                </button>
              </>
            ) : (
              <div className="auth-dropdown-login">
                <p>Connectez-vous pour accéder à votre compte</p>
              </div>
            )}
          </div>
        </>
      )}

      {/* Auth Modal */}
      <AuthModal 
        isOpen={isAuthModalOpen} 
        onClose={() => setIsAuthModalOpen(false)} 
      />
    </div>
  );
};

export default AuthButton;
